import { http } from "common/helpers/axios/axios-helper";
import { buildFilterString, buildQueryString } from "common/helpers/queryUtils";
import { NotificationHistory, NotificationHistoryFilter, NotificationHistoryResponse } from "../models/notification-history.model";

const basePath = '/notificationhistory';

async function getNotificationHistory({
  pageNumber = 1,
  pageSize = 30,
  ...params }: NotificationHistoryFilter & { pageNumber?: number; pageSize?: number }) {

  const queryString = buildQueryString({
    page: pageNumber,
    limit: pageSize
  });

  const filterParams = {
    startDate: params.startDate?.toISOString(),
    endDate: params.endDate?.toISOString(),
    channelId: params.channelId?.toString(),
    statusId: params.statusId?.toString()
  };

  const filterString = buildFilterString(filterParams);
  const url = `${basePath}${queryString}${filterString}`;

  console.log('URL completa:', url);

  return await http.get<NotificationHistoryResponse>(url);
}

async function getNotificationDetails(id: number) {
  return await http.get<NotificationHistory>(`${basePath}/${id}`);
}

export const NotificationHistoryService = {
  getNotificationHistory,
  getNotificationDetails
};